import { render, staticRenderFns } from "./SellerList.vue?vue&type=template&id=56160a9f&"
import script from "./SellerList.vue?vue&type=script&lang=js&"
export * from "./SellerList.vue?vue&type=script&lang=js&"
import style0 from "./SellerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports